import { EmptyState } from "@cmde/shadcn";
import { CalendarDays } from "lucide-react";
import { useTranslation } from "react-i18next";

export function EmptySeasonsList() {
  const { t } = useTranslation();

  return (
    <EmptyState
      title={t("seasons.list.general.no_seasons_found")}
      description={t("seasons.list.general.no_seasons_description")}
      icon={<CalendarDays />}
    />
  );
}
